import React, { memo, useState, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import setClass from '../../common/set-class';
import TextInput from '../text-input';
import Button from '../button';
const CollapsableSearchInput = ({ value, onChange, className, style }) => {
    const wrapperRef = useRef(null);
    const [isCollapsed, setIsCollapsed] = useState(true);
    const handleChange = useCallback((e) => onChange(e.target.value), [onChange]);
    const handleButtonClick = useCallback(() => {
        setIsCollapsed(!isCollapsed);
        if (value) {
            onChange('');
        }
    }, [isCollapsed, value]);
    const onBlur = useCallback(() => !value && setIsCollapsed(true), [value]);
    const isReallyCollapsed = isCollapsed && !value;
    return (React.createElement("div", { ref: wrapperRef, className: setClass('b-collapsable-search', className), style: style },
        !isReallyCollapsed && (React.createElement(TextInput, { value: value, onChange: handleChange, className: "b-collapsable-search__input", autoFocus: true, onBlur: onBlur })),
        React.createElement(Button, { onClick: handleButtonClick, kind: "link", icon: value ? 'circle-xmark' : 'magnifying-glass', className: "b-collapsable-search__button" }, isReallyCollapsed ? 'Search' : '')));
};
CollapsableSearchInput.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
    style: PropTypes.object,
};
CollapsableSearchInput.defaultProps = {
    value: '',
    className: undefined,
    style: undefined,
};
export default memo(CollapsableSearchInput);
